import React, {forwardRef, useCallback, useEffect, useImperativeHandle, useState} from 'react';
import DroppableList from '../DraggingWrappers/DroppableList';
import styles from "../Merging.module.css";
import Constraint from "../../Constraint/Constraint";
import PulsingDivWrapper from "../DraggingWrappers/PulsingDivWrapper";


const ConstraintsMergingDisplay = forwardRef (({ patternSelected, fromPattern, toPattern }, ref) => {
    const [fromList, setFromList] = useState([]);
    const [toList, setToList] = useState([]);
    const [draggingTo, setDraggingTo] = useState(false)
    const [draggingFrom, setDraggingFrom] = useState(false)

    const existsInToList = useCallback((item) => {
        return (
            Array.isArray(toList) &&
            item && item.constraint &&
            toList.some(f => +item.constraint.constraint_id === +f.constraint.constraint_id)
        );
    }, [toList]);

    const existsInFromList = useCallback((item) => {
        return (
            Array.isArray(fromList) &&
            item && item.constraint &&
            fromList.some(f => +item.constraint.constraint_id === +f.constraint.constraint_id)
        );
    }, [fromList]);

    useEffect(() => {
        if (fromPattern && fromPattern.constraints) {
            setFromList(fromPattern.constraints.map((constraint, index) => {
                const id = constraint.constraint_id + " patternId-" + fromPattern.pattern_id
                const isGrayedOut = existsInToList({ constraint: constraint });
                return {
                    id,
                    constraint,
                    content: <div className={isGrayedOut ? styles.GrayedOut : ''}><Constraint constraint={constraint} extraStyle={`${styles.FromColor} ${styles.FromTextColor}`}/></div>,
                    index,
                    disableDrag: isGrayedOut
                }
            }))
        }
    }, [fromPattern, patternSelected, existsInToList]);

    useEffect(() => {
        if (toPattern && toPattern.constraints) {
            setToList(toPattern.constraints.map((constraint, index) => {
                const id = constraint.constraint_id + " patternId-" + toPattern.pattern_id
                return {
                    id,
                    constraint,
                    content: <Constraint constraint={constraint}/>,
                    index,
                    disableDrag: true
                }
            }))
        }
    }, [toPattern, patternSelected]);

    const moveItemBetweenLists = (item, start, destination) => {
        if (start === destination) {
            return;
        }
        if (start === 'fromList' && destination === 'toList' && !existsInToList(item)) {
            let newItem = {...item}
            newItem.content = <Constraint constraint={item.constraint} extraStyle={`${styles.FromColor} ${styles.FromTextColor}`}/>
            setToList(prev => [newItem, ...prev]); // Add to target
        } else if (start === 'toList' && destination === 'fromList' && existsInFromList(item)) {
            setToList(prev => prev.filter(i => +i.constraint.constraint_id !== +item.constraint.constraint_id))
        }
    };

    useImperativeHandle(ref, () => ({
        getList: () => {
            return toList.map(item => item.constraint);  // Return the current state of toList
        }
    }));

    return (
        <div className={styles.Container}>
            {/*This style is kinda cursed but it will likely not be necessary once constraints uses pattern component*/}
            <div className={styles.SplitCols} style={{maxWidth: '50%', marginRight: '-2.5%', paddingRight: '10px'}}>
                <h3>Constraints:</h3>
                <PulsingDivWrapper active={draggingFrom}>
                    <DroppableList
                        list={toList}
                        setList={setToList}
                        itemType={'CONSTRAINTS'}
                        targetListName="toList"
                        moveItemBetweenLists={moveItemBetweenLists}
                        setDragging={setDraggingTo}
                    />
                </PulsingDivWrapper>
            </div>
            <div className={styles.Separator}></div>
            <div className={styles.SplitCols} style={{maxWidth: '50%', marginLeft: '-2.5%', paddingLeft: '10px'}}>
                <h3>Constraints:</h3>
                <PulsingDivWrapper active={draggingTo}>
                    <DroppableList
                        list={fromList}
                        setList={setFromList}
                        itemType={'CONSTRAINTS'}
                        targetListName="fromList"
                        moveItemBetweenLists={moveItemBetweenLists}
                        setDragging={setDraggingFrom}
                    />
                </PulsingDivWrapper>
            </div>
        </div>
    )
});

export default ConstraintsMergingDisplay;
